import { ForestCrewEdit } from '@features/Contractor/ForestCrew/Edit/ForestCrewEdit'
import { useForestCrewContext } from '@features/Contractor/ForestCrew/ForestCrewContext'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const ForestCrewEditRoute: React.FC = () => {
  const { contractorId } = Route.useParams()
  const { data, isLoading, isError, refetch } = useForestCrewContext()

  return (
    <ForestCrewEdit
      contractorId={contractorId}
      data={data}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
    />
  )
}

export const Route = createFileRoute('/contractor/$contractorId/forest-crews/$forestCrewId/edit/')({
  component: ForestCrewEditRoute,
  staticData: {
    breadcrumb: t('contractor.forestCrew.edit.title'),
  },
})
